import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { getDeployment } from '@/redux/modules/config';

import { fetchArticleByTopicAndSlug } from './article.api';
import { Article, FetchArticleParams } from './article.types';

export const fetchArticle = createAsyncThunk<Article | null, FetchArticleParams>(
    'la/ui/article/fetchArticle',
    async ({ slug, topic }, { getState }) => {
        const state = getState();
        const deployment = getDeployment(state);

        return fetchArticleByTopicAndSlug({ deployment, slug, topic });
    }
);
